import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { sessionStorage } from '@shared/helpers/storage'
import env from '@shared/env.js'

export const useSelfTestStore = defineStore(
  'selfTest',
  () => {
    // State
    /** @type {import('vue').Ref<"m"|"f"|"u">} */
    const gender = ref(null)
    const worstPainLocation = ref('')
    const fitnessActivities = ref([])
    const chronificationLevels = ref([])
    /** @type {import('vue').Ref<boolean>} */
    const redFlagApproved = ref(null)
    const painIntensity = ref(-1)
    const initialFearOfMovement = ref(-1)

    // Getters
    const selfTestAnswers = computed(() => {
      const fitness_activities = fitnessActivities.value
        .filter((a) => a.checked)
        .map((a) => a.value)

      let chronification_level = chronificationLevels.value.filter(
        (l) => l.checked,
      )
      chronification_level =
        (chronification_level.length && chronification_level[0].value) || null

      return env.isCopd
        ? {
            ...(gender.value != null ? { gender: gender.value } : {}),
            red_flag_approved: redFlagApproved.value ? 1 : null,
            fitness_activities:
              fitness_activities.length > 0 ? fitness_activities : null,
            ...(painIntensity.value > -1
              ? { pain_level: painIntensity.value }
              : {}),
            ...(initialFearOfMovement.value > -1
              ? { 'fear-of-movement': initialFearOfMovement.value }
              : {}),
          }
        : {
            gender: gender.value,
            red_flag_approved: redFlagApproved.value ? 1 : null,
            fitness_activities:
              fitness_activities.length > 0 ? fitness_activities : null,
            'pain-location': [worstPainLocation.value],
            worst_pain_location: worstPainLocation.value,
            chronification_level,
            ...(initialFearOfMovement.value > -1
              ? { 'fear-of-movement': initialFearOfMovement.value }
              : {}),
            ...(painIntensity.value > -1
              ? { pain_level: painIntensity.value }
              : {}),
          }
    })

    const selectedFitnessActivities = computed(() =>
      fitnessActivities.value.filter((f) => f.checked),
    )

    const selectedChronificationLevels = computed(() =>
      chronificationLevels.value.filter((c) => c.checked),
    )

    // Actions
    function updateFitnessActivities(item) {
      fitnessActivities.value.forEach((f) => {
        f.checked = f.value === item.value ? item.checked : f.checked
      })
    }

    function updateChronificationLevels(item) {
      chronificationLevels.value.forEach((c) => {
        c.checked = c.value === item.value
      })
    }

    return {
      // State
      gender,
      worstPainLocation,
      fitnessActivities,
      chronificationLevels,
      redFlagApproved,
      painIntensity,
      initialFearOfMovement,
      // Getters
      selfTestAnswers,
      selectedFitnessActivities,
      selectedChronificationLevels,
      // Actions
      updateFitnessActivities,
      updateChronificationLevels,
    }
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
)

export default useSelfTestStore
